"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnScroll = void 0;
const react_1 = require("react");
const useOnWheel_1 = require("./useOnWheel");
function useOnScroll(onScroll) {
    const onScrollRef = react_1.useRef(onScroll);
    react_1.useEffect(() => {
        onScrollRef.current = onScroll;
    }, [onScroll]);
    return useOnWheel_1.useOnWheel(e => {
        onScrollRef.current(e.originalEvent.deltaX);
    });
}
exports.useOnScroll = useOnScroll;
//# sourceMappingURL=useOnScroll.js.map